import { UseQueryResult, useQuery } from '@tanstack/react-query'
import { generateThemesV2 } from 'tripPlanner/api'
import * as ThemeKeys from '../reactQueryKeys/themes'

export interface ThemeItem {
  theme: string
  description: string
}

export const useGenerateThemesV2 = (
  { offerId, cartId, orderId, locationIds, region }: {
    offerId?: string
    cartId?: string
    orderId?: string
    region?: string
    locationIds?: Array<string>
  },
): UseQueryResult<Array<ThemeItem> | undefined> => {
  const hasValidParams = !!offerId || !!cartId || !!orderId || !!locationIds
  return useQuery(
    ThemeKeys.themesV2(offerId, cartId, orderId, locationIds, region),
    async() => {
      if (!hasValidParams) {
        return undefined
      }
      return generateThemesV2({ offerId, cartId, orderId, locationIds, region })
    },
    {
      enabled: hasValidParams,
    },
  )
}
